import React from 'react';

const Faqs = () => {
  const faqs = [
    {
      question: "What is this platform about?",
      answer: "This platform connects users with their favorite restaurants, allowing them to browse menus, place orders, and enjoy a seamless food delivery experience.",
    },
    {
      question: "How do I create an account?",
      answer: "Click on the 'Sign Up' button on the homepage, fill in your details, and follow the instructions to create your account.",
    },
    {
      question: "Can I cancel my order?",
      answer: "Yes, you can cancel your order before it is confirmed by the restaurant. Once confirmed, cancellations may not be possible.",
    },
    {
      question: "How do I contact customer support?",
      answer: "You can reach out to our customer support team via the 'Contact Us' page or by emailing support@platoo.com.",
    },
    {
      question: "Is my payment information secure?",
      answer: "Yes, we use industry-standard encryption to ensure your payment information is safe and secure.",
    },
  ];

  return (
    <div className="container p-4">
      <h1>Frequently Asked Questions (FAQs)</h1>
      <div>
        {faqs.map((faq, index) => (
          <div key={index} style={{ marginBottom: '20px' }}>
            <h3 style={{ marginBottom: '5px', color: '#007bff' }}>{faq.question}</h3>
            <p style={{ margin: '0', color: '#555' }}>{faq.answer}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faqs;